import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-56 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
            Legal services that make sense
          </h1>
          <p className="text-xl text-[#6B7280] leading-relaxed">
            Clear, practical legal help for the situations that matter most to individuals and businesses
          </p>
        </div>
      </section>

      {/* Service 1: Contract Drafting & Review */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
            <div className="md:col-span-7">
              <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
                Core Service
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
                Contract Drafting &amp; Review
              </h2>
              <p className="text-lg text-[#374151] mb-6 leading-relaxed">
                Contracts are the foundation of every business relationship. We draft clear, enforceable agreements that protect your interests and prevent future disputes. Whether you're entering a new partnership, hiring contractors, or selling products, having the right contract in place is essential.
              </p>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                We also review contracts you've been asked to sign, explaining what they actually mean and identifying any terms that could create problems down the road.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Service agreements and vendor contracts</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Partnership and operating agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Employment and contractor agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Non-disclosure and confidentiality agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Purchase and sale agreements</span>
                </li>
              </ul>
              <Link to="/contact" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Discuss this service →
              </Link>
            </div>
            <div className="md:col-span-5">
              <div className="rounded-3xl overflow-hidden h-[500px]">
                <img 
                  src="https://public.readdy.ai/ai/img_res/1dbc797b03eda845f395cd08289630ee.jpg"
                  alt="Contract Review"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service 2: Business Formation */}
      <section className="py-24 px-6 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
            <div className="md:col-span-5 order-2 md:order-1">
              <div className="rounded-3xl overflow-hidden h-[500px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Entrepreneur%20planning%20new%20business%20startup%20with%20laptop%20and%20documents%20on%20modern%20workspace%2C%20bright%20natural%20lighting%20through%20windows%2C%20clean%20contemporary%20office%20with%20plants%20and%20minimal%20design%2C%20optimistic%20and%20professional%20atmosphere%2C%20warm%20neutral%20color%20palette%20with%20soft%20beige%20and%20white%20tones%2C%20inspiring%20business%20photography&width=800&height=1000&seq=business-formation-001&orientation=portrait"
                  alt="Business Formation"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="md:col-span-7 order-1 md:order-2">
              <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
                Core Service
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
                Business Formation &amp; Structure
              </h2>
              <p className="text-lg text-[#374151] mb-6 leading-relaxed">
                Starting a business means making important decisions about structure, liability protection, and tax treatment. We help you choose the right entity type and set it up correctly from the beginning, so you don't have to fix problems later.
              </p>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                Whether you're launching a new venture or restructuring an existing business, we make sure your legal foundation is solid and appropriate for your goals.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>LLC and corporation formation</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Entity selection and structure planning</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Operating agreements and bylaws</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Business restructuring and conversions</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Compliance and ongoing legal requirements</span>
                </li>
              </ul>
              <Link to="/contact" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Discuss this service →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service 3: Commercial Agreements */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
            <div className="md:col-span-7">
              <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
                Core Service
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
                Commercial Agreements
              </h2>
              <p className="text-lg text-[#374151] mb-6 leading-relaxed">
                Business deals require clear agreements that define expectations, responsibilities, and remedies if things don't go as planned. We draft and negotiate commercial agreements that protect your interests while maintaining good business relationships.
              </p>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                From simple vendor agreements to complex joint ventures, we make sure the terms are fair, enforceable, and aligned with your business objectives.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Supplier and distribution agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Licensing and intellectual property agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Joint venture and collaboration agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Lease and real estate agreements</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Terms of service and customer agreements</span>
                </li>
              </ul>
              <Link to="/contact" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Discuss this service →
              </Link>
            </div>
            <div className="md:col-span-5">
              <div className="rounded-3xl overflow-hidden h-[500px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Two%20business%20professionals%20shaking%20hands%20after%20successful%20agreement%20in%20modern%20office%20conference%20room%2C%20natural%20daylight%20from%20large%20windows%2C%20clean%20contemporary%20interior%20with%20neutral%20warm%20tones%2C%20professional%20and%20trustworthy%20atmosphere%2C%20sophisticated%20business%20photography%20with%20soft%20lighting%20and%20minimal%20background&width=800&height=1000&seq=commercial-agreement-001&orientation=portrait"
                  alt="Commercial Agreements"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service 4: Asset Protection */}
      <section className="py-24 px-6 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
            <div className="md:col-span-5 order-2 md:order-1">
              <div className="rounded-3xl overflow-hidden h-[500px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Secure%20vault%20door%20or%20modern%20safe%20in%20professional%20office%20setting%20with%20clean%20architectural%20lines%2C%20sophisticated%20security%20concept%20with%20warm%20neutral%20tones%20and%20soft%20lighting%2C%20minimalist%20design%20emphasizing%20protection%20and%20trust%2C%20high-end%20business%20photography%20style%20with%20subtle%20shadows%20and%20depth&width=800&height=1000&seq=asset-protection-001&orientation=portrait"
                  alt="Asset Protection"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="md:col-span-7 order-1 md:order-2">
              <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
                Core Service
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
                Asset Protection Planning
              </h2>
              <p className="text-lg text-[#374151] mb-6 leading-relaxed">
                Protecting what you've built requires thoughtful planning and proper legal structures. We help business owners and individuals implement strategies to safeguard assets from potential claims, lawsuits, and business risks.
              </p>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                Our approach focuses on practical, legally sound methods that provide real protection without unnecessary complexity or cost.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Business entity structuring for liability protection</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Personal asset protection strategies</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Risk assessment and mitigation planning</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Insurance review and recommendations</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Estate planning coordination</span>
                </li>
              </ul>
              <Link to="/contact" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Discuss this service →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service 5: General Business Counsel */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
            <div className="md:col-span-7">
              <p className="text-sm font-semibold text-[#C4704B] uppercase tracking-wider mb-4">
                Core Service
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
                General Business Counsel
              </h2>
              <p className="text-lg text-[#374151] mb-6 leading-relaxed">
                Running a business means dealing with legal questions on a regular basis. We provide ongoing counsel to help you navigate day-to-day legal issues, make informed decisions, and avoid problems before they start.
              </p>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                Think of us as your legal resource for everything from employment questions to contract disputes to compliance requirements.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Day-to-day legal guidance and advice</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Employment and HR legal support</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Regulatory compliance assistance</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Dispute resolution and negotiation</span>
                </li>
                <li className="flex items-start text-base text-[#374151]">
                  <span className="mr-3 mt-1">—</span>
                  <span>Strategic legal planning</span>
                </li>
              </ul>
              <Link to="/contact" className="text-[#C4704B] font-medium hover:text-[#A85A3A] transition-colors whitespace-nowrap">
                Discuss this service →
              </Link>
            </div>
            <div className="md:col-span-5">
              <div className="rounded-3xl overflow-hidden h-[500px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20legal%20consultation%20meeting%20with%20lawyer%20and%20client%20discussing%20business%20matters%20at%20modern%20office%20desk%2C%20warm%20natural%20lighting%20from%20windows%2C%20clean%20contemporary%20workspace%20with%20neutral%20tones%2C%20collaborative%20and%20approachable%20atmosphere%2C%20sophisticated%20business%20photography%20with%20soft%20focus%20background&width=800&height=1000&seq=business-counsel-001&orientation=portrait"
                  alt="General Business Counsel"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Overview Section */}
      <section className="py-32 px-6 bg-[#1A2332]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-20 text-center">
            How we work together
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div className="text-center">
              <div className="text-6xl font-bold text-white/20 mb-4">01</div>
              <h3 className="text-xl font-bold text-white mb-3">Initial Conversation</h3>
              <p className="text-base text-white/80 leading-relaxed">
                We start by understanding your situation and what you're trying to accomplish.
              </p>
            </div>
            <div className="text-center">
              <div className="text-6xl font-bold text-white/20 mb-4">02</div>
              <h3 className="text-xl font-bold text-white mb-3">Clear Assessment</h3>
              <p className="text-base text-white/80 leading-relaxed">
                We explain your options, potential risks, and what legal work is actually needed.
              </p>
            </div>
            <div className="text-center">
              <div className="text-6xl font-bold text-white/20 mb-4">03</div>
              <h3 className="text-xl font-bold text-white mb-3">Practical Solutions</h3>
              <p className="text-base text-white/80 leading-relaxed">
                We provide clear documents and advice that protect your interests.
              </p>
            </div>
            <div className="text-center">
              <div className="text-6xl font-bold text-white/20 mb-4">04</div>
              <h3 className="text-xl font-bold text-white mb-3">Ongoing Support</h3>
              <p className="text-base text-white/80 leading-relaxed">
                We're available when questions come up or your needs change.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Philosophy Section */}
      <section className="py-28 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A2332] mb-8 text-center">
            Transparent pricing, no surprises
          </h2>
          <p className="text-lg text-[#374151] mb-6 leading-relaxed">
            We believe you should know what legal work will cost before we start. For most services, we provide flat-fee pricing or clear estimates based on the scope of work. No surprise bills, no padding hours, and no charging you for every email.
          </p>
          <p className="text-lg text-[#374151] mb-10 leading-relaxed">
            Our goal is to provide value, not to maximize billable time. If something will cost more than expected, we'll tell you before proceeding.
          </p>
          <div className="bg-[#F8F9FA] border-l-4 border-[#C4704B] p-8 rounded-lg">
            <p className="text-lg text-[#1A2332] text-center leading-relaxed">
              Every engagement starts with a clear conversation about scope and cost
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="px-6 pb-0">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="bg-[#1A2332] p-16 md:p-20 flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Ready to move forward?
              </h2>
              <p className="text-lg text-white/90 mb-8 leading-relaxed">
                Let's discuss your legal needs and how we can help.
              </p>
              <Link 
                to="/contact"
                className="inline-block border-2 border-white text-white px-8 py-3 rounded-lg font-medium hover:bg-white hover:text-[#1A2332] transition-all duration-300 whitespace-nowrap text-center"
              >
                Get in touch
              </Link>
            </div>
            <div className="bg-[#F5F6F7] p-16 md:p-20 flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1A2332] mb-6">
                Not sure where to start?
              </h2>
              <p className="text-lg text-[#374151] mb-8 leading-relaxed">
                We're happy to have an exploratory conversation about your situation.
              </p>
              <Link 
                to="/contact"
                className="inline-block bg-[#C4704B] text-white px-8 py-3 rounded-lg font-medium hover:bg-[#A85A3A] transition-all duration-300 whitespace-nowrap text-center"
              >
                Schedule a call
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
